import {validateDatoCmsTypes} from './common.serde'
import {
  RegionalIndustryFieldsFragment,
  RelatedIndustrySectionFieldsFragment,
} from '../../../../__generated__/datocms.types'
import {RelatedIndustrySection} from '../types/related-industry-section.types'
import {parseRegionalIndustry} from './craftsmen-region-page.serde'

export function parseRelatedIndustrySection(
  s: RelatedIndustrySectionFieldsFragment,
  relatedIndustries: RegionalIndustryFieldsFragment[],
): RelatedIndustrySection {
  const section = validateDatoCmsTypes(s)
  return {
    __type: 'RelatedIndustrySection',
    id: section.id,
    title: section.title,
    industries: relatedIndustries.map(i => parseRegionalIndustry(i)),
  }
}
